






































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
  GetAssessFormTableColumns,
  DeleteAssessFormTableColumn,
} from "@/api/assessForm";
import configColumnsAdd from "./configColumnsAdd.vue";
import formTable from "./formTable.vue";

@Component({
  components: { configColumnsAdd, formTable },
})
export default class extends AbpBase {
  @Prop() data: any;
  @Prop() value: boolean;
  tableData: any = [];
  loading = false;
  configColumnsAddShow = false;
  configColumnsAddData = {};
  formTableShow = false;
  columns: any = [
    {
      title: "排序码",
      key: "sort",
    },
    {
      title: "字段编码",
      key: "model",
    },
    {
      title: "字段名称",
      key: "label",
    },
    {
      title: "字段类型",
      key: "type",
    },
    {
      title: "操作",
      width: 220,
      render: (h1: any, p: any) => {
        const h = this.$createElement;
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "10px",
              },
              on: {
                click: () => {
                  this.edit(p.row);
                },
              },
            },
            "修改"
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: () => {
                  this.del(p.row);
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];

  created() {
    this.getData();
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  async getData() {
    this.loading = true;
    let res = await GetAssessFormTableColumns({
      formId: this.data.form.id,
    });
    this.tableData = res.objects;
    this.loading = false;
  }

  add() {
    this.configColumnsAddData = {
      mode: "add",
      formData: this.data.form,
    };
    this.configColumnsAddShow = true;
  }

  edit(row: any) {
    this.configColumnsAddData = {
      mode: "edit",
      formData: this.data.form,
      model: row,
    };
    this.configColumnsAddShow = true;
  }

  del(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要删除吗？",
      onOk: async () => {
        await DeleteAssessFormTableColumn({ id: row.id });
        this.getData();
      },
    });
  }

  preview() {
    this.formTableShow = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/formBuilder/configColumns.vue